export default {
  getUsersEvaluation: (state) => state.usersEvaluation?.data,
  // getUsersEvaluationPagination: (state) => state.usersEvaluation?.pagination,
};